export default "__VITE_ASSET__Bzcl4oZD__"